exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Content-module__video-link___2z_Mq{border:none}", ""]);

// exports
exports.locals = {
	"video-link": "Content-module__video-link___2z_Mq"
};